//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../../components/chartOTPPurchase";
import axios, { CancelToken } from "axios";
// import ChartOTP from "../components/chartOTP.vue";
export default {
  components: {
    chartOTP,
  },
  data() {
    return {
      chartF: {
        ALL: [],
        NIKE: [],
        NONNIKE: [],
      },
      chartS: {
        ALL: [],
        NIKE: [],
        NONNIKE: [],
      },
      chartP: {
        ALL: [],
        NIKE: [],
        NONNIKE: [],
      },
      ps: "202001",
      pe: "202053",
      // apiS: `${this.$apiFix}OTPProcurementVN.php/sew`,
      // apiP: `${this.$apiFix}OTPProcurementVN.php/pack`,
      api: `${this.$apiFix}`,
    };
  },
  async mounted() {
    let a = await this.defaultPeriod();
    this.loadDataFabric();
    this.loadDataSew();
    this.loadDataPack();
  },
  methods: {
    goPage(routerName) {
      this.$router.push({
        name: routerName,
      });
    },
    defaultPeriod() {
      let params = new FormData();
      const obj = axios({
        method: "post",
        url: this.$api + "otpmaster.php/otperiod",
        data: params,
      }).then((res) => {
        this.ps = res.data.ps;
        this.pe = res.data.pe;
      });

      return obj;
    },

    loadDataFabric() {

      axios
        .get(
          `${this.api}otp_fabric.php/vn?ps=${this.ps}&pe=${this.pe}&loc=`
        )
        .then((response) => {
          this.chartF.ALL = response.data;
        });

      axios
        .get(
          `${this.api}otp_fabric.php/vn?ps=${this.ps}&pe=${this.pe}&loc=NIKE`
        )
        .then((response) => {
          this.chartF.NIKE = response.data;
        });

      axios
        .get(
          `${this.api}otp_fabric.php/vn?ps=${this.ps}&pe=${this.pe}&loc=NON-NIKE`
        )
        .then((response) => {
          this.chartF.NONNIKE = response.data;
        });

    },

    loadDataSew() {
      axios
        .get(
          `${this.api}otp_sew.php/vn?ps=${this.ps}&pe=${this.pe}&loc=`
        )
        .then((response) => {
          this.chartS.ALL = response.data;
        });
      axios
        .get(
          `${this.api}otp_sew.php/vn?ps=${this.ps}&pe=${this.pe}&loc=NIKE`
        )
        .then((response) => {
          this.chartS.NIKE = response.data;
        });
      axios
        .get(
          `${this.api}otp_sew.php/vn?ps=${this.ps}&pe=${this.pe}&loc=NON-NIKE`
        )
        .then((response) => {
          this.chartS.NONNIKE = response.data;
        });
    },

    loadDataPack() {
      axios
        .get(
          `${this.api}otp_pack.php/vn?ps=${this.ps}&pe=${this.pe}&loc=`
        )
        .then((response) => {
          this.chartP.ALL = response.data;
        });
      axios
        .get(
          `${this.api}otp_pack.php/vn?ps=${this.ps}&pe=${this.pe}&loc=NIKE`
        )
        .then((response) => {
          this.chartP.NIKE = response.data;
        });
      axios
        .get(
          `${this.api}otp_pack.php/vn?ps=${this.ps}&pe=${this.pe}&loc=NON-NIKE`
        )
        .then((response) => {
          this.chartP.NONNIKE = response.data;
        });
    },
  },
};
